import React from 'react';
import { Hospital } from 'types/hospital';
import HospitalItemModule from './HospitalItemModule';
import List from 'components/list/List';

type HospitalListModuleProps = {
  hospitals: Hospital[];
};

const HospitalListModule: React.FC<HospitalListModuleProps> = ({ hospitals }) => {
  return (
    <List>
      {hospitals.map(hospital => (
        <HospitalItemModule key={hospital.id} hospital={hospital} />
      ))}
    </List>
  );
};

export default HospitalListModule;
